import { render, staticRenderFns } from "./DemoEmployeeCreate.vue?vue&type=template&id=76b13904&scoped=true&"
import script from "./DemoEmployeeCreate.vue?vue&type=script&lang=js&"
export * from "./DemoEmployeeCreate.vue?vue&type=script&lang=js&"
import style0 from "./DemoEmployeeCreate.vue?vue&type=style&index=0&id=76b13904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b13904",
  null
  
)

export default component.exports